import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Checkbox = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.243 28 4 25.757 4 23V9C4 6.243 6.243 4 9 4H23C25.757 4 28 6.243 28 9V23C28 25.757 25.757 28 23 28ZM9 6C7.346 6 6 7.346 6 9V23C6 24.654 7.346 26 9 26H23C24.654 26 26 24.654 26 23V9C26 7.346 24.654 6 23 6H9Z" />
		<path d="M22 11C22 10.448 21.552 10 21 10C20.664 10 20.367 10.166 20.186 10.421C20.184 10.423 13.973 19.296 13.973 19.296C13.973 19.296 11.796 16.395 11.794 16.393C11.611 16.155 11.324 16 11.001 16C10.449 16 10.001 16.448 10.001 17C10.001 17.222 10.074 17.426 10.196 17.591C10.198 17.594 13.204 21.602 13.206 21.604C13.389 21.844 13.676 22 14.001 22C14.338 22 14.636 21.832 14.817 21.576C14.818 21.575 21.821 11.571 21.822 11.569C21.935 11.407 22.001 11.211 22.001 10.999L22 11Z" />
	</svg>
);

export default Checkbox;
